import { APIModel } from 'app/state/api';
import { ApiCallModel } from 'app/state/api/interfaces';

const billingDetails: ApiCallModel = {
  ...APIModel(`${process.env.REACT_APP_PAYMENTS_API}/get-billing-details`),
};

export default billingDetails;
